import React, { useEffect } from 'react';
import './commercialwork.css';

export default function Work() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  // Reveal with a tiny stagger, and force the first two items visible
  useEffect(() => {
    const items = Array.from(
      document.querySelectorAll(
        '.work, .work2, .work3, .work4, video.work, video.work2, video.work3, video.work4'
      )
    );

    // Force-reveal first 2 tiles so the first video never stays hidden
    items.slice(0, 2).forEach((el, i) => {
      el.classList.add('is-visible');
      el.style.transitionDelay = `${i * 40}ms`;
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const idx = items.indexOf(e.target);
            if (!e.target.style.transitionDelay) {
              e.target.style.transitionDelay = `${(idx % 6) * 40}ms`;
            }
            e.target.classList.add('is-visible');
            io.unobserve(e.target); // reveal once
          }
        });
      },
      { threshold: 0.01, rootMargin: '12% 0px -8% 0px' }
    );

    items.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  // Soft micro-parallax/sheen on scroll (kept subtle)
  useEffect(() => {
    const rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (rm) return;
    const onScroll = () => {
      const y = Math.min(800, window.scrollY || 0);
      const p = y / 800;
      document.documentElement.style.setProperty('--banner-parallax', `${Math.round(p * 20)}px`);
      document.documentElement.style.setProperty('--header-glow', (0.08 + p * 0.12).toFixed(3));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="main-body fade-in">
      {/* ===== Title block directly under navbar ===== */}
      <header className="portfolio-header luxe-enter" role="banner">
        <div className="ph-inner">
          <h1 className="ph-title">
            Commercial Work
    
          </h1>
          <p className='ph-sub1'>
            Years photographing Dove campaigns for Unilever taught me precision, light discipline, and the quiet art of visual honesty. That commercial foundation deepened my desire to tell human stories with the same care — leading me to humanitarian work that values empathy, authenticity, and dignity over perfection.
          </p>
          <p className="ph-sub">
            
            All works are property of the respective brands. These are displayed for portfolio purposes only.
          </p>
        </div>
      </header>

      {/* ===== Banner (after header) ===== */}
      <div className="banner fade-in hidden">
        <img
          className="banner-image kenburns-top parallax-slight"
          src="https://lorranlima.s3.us-east-2.amazonaws.com/commercialbannerdesk.jpg"
          alt=""
        />
        <img
          className="banner-image-mobile kenburns-top parallax-slight"
          src="https://lorranlima.s3.us-east-2.amazonaws.com/commercialbannermob.jpg"
          alt=""
        />
      </div>

      {/* ===== Main grid ===== */}
      <div className="main-page pad-top-20 smaller black top-drop">
        <div className="full-white-back">
          {/* (Old inline title removed; we use the header above) */}
          <div className="fade-in grid-stagger">
            <div className="desktop-margin-top" />

            <video className="work2" loop muted defaultMuted autoPlay playsInline preload="metadata"
              src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/RPReplay_Final1647212245+(1).mp4" />
            <video className="work2" loop muted defaultMuted autoPlay playsInline preload="metadata"
              src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/RPReplay_Final1647213238.mp4" />
            <img className="work2" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/cw1.jpeg" alt="" />
            <img className="work2" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/cw2.jpeg" alt="" />

            <img className="work2" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/dovee.JPG" alt="" />
            <img className="work2" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/dovee2.JPG" alt="" />
            <img className="work2" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7495.JPG" alt="" />

            <img className="work2" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/079A9799.JPG" alt="" />
            <img className="work2" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/079A9760.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/dove14.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_4763.JPG" alt="" />
            <video className="work" loop muted defaultMuted autoPlay playsInline preload="metadata"
              src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/RPReplay_Final1647213298.mp4" />

            <video className="work2" loop muted defaultMuted autoPlay playsInline preload="metadata"
              src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/RPReplay_Final1647212450.mp4" />
            <video className="work2" loop muted defaultMuted autoPlay playsInline preload="metadata"
              src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/RPReplay_Final1647215641.mp4" />

            <video className="work" loop muted defaultMuted autoPlay playsInline preload="metadata"
              src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/RPReplay_Final1647387027.mp4" />
            <video className="work" loop muted defaultMuted autoPlay playsInline preload="metadata"
              src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/RPReplay_Final1647217848+(1)+(1).mp4" />
            <img className="work2" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7395.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7290.jpg" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7408.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7410.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7418.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7419.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7430.jpg" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7438.jpg" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7448.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7446.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7452.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7453.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7454.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7456.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7450.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7471.jpg" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7475.jpg" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7491.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7264.jpg" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7284.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7311.JPG" alt="" />

            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7353.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7356.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7357.jpg" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7374.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7382.JPG" alt="" />
            <img className="work" src="https://lorrancommercialwork.s3.us-east-2.amazonaws.com/IMG_7390.JPG" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}
